var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 4.16602C4.375 3.82084 4.65482 3.54102 5 3.54102H15C15.3452 3.54102 15.625 3.82084 15.625 4.16602V10.8327C15.625 11.1779 15.3452 11.4577 15 11.4577H10.625V15.2077H17.5C17.8452 15.2077 18.125 15.4875 18.125 15.8327C18.125 16.1779 17.8452 16.4577 17.5 16.4577H2.5C2.15482 16.4577 1.875 16.1779 1.875 15.8327C1.875 15.4875 2.15482 15.2077 2.5 15.2077H9.375V11.4577H5C4.65482 11.4577 4.375 11.1779 4.375 10.8327V4.16602ZM5.625 4.79102V10.2077H14.375V4.79102H5.625Z",
    fill: "#9897A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92644 7.03386C8.183 7.26478 8.2038 7.65996 7.97289 7.91653L7.96456 7.92579C7.73365 8.18235 7.33846 8.20315 7.0819 7.97224C6.82533 7.74133 6.80453 7.34615 7.03544 7.08958L7.04377 7.08032C7.27469 6.82375 7.66987 6.80295 7.92644 7.03386Z",
    fill: "#9897A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4264 7.03386C10.683 7.26478 10.7038 7.65996 10.4729 7.91653L10.4646 7.92579C10.2336 8.18235 9.83846 8.20315 9.5819 7.97224C9.32533 7.74133 9.30453 7.34615 9.53544 7.08958L9.54377 7.08032C9.77469 6.82375 10.1699 6.80295 10.4264 7.03386Z",
    fill: "#9897A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerConnection);
export default __webpack_public_path__ + "static/media/server-connection.a5bc79f3112b161c3b3e9141f6625034.svg";
export { ForwardRef as ReactComponent };